module.exports = "<div class=\"redBorder\" (click)=\"onDelete()\">\n  Angular 7 Hero 1 {{nameForName}}\n</div>";